<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group m-0">
                                    <label for="">Выберите год</label>
                                    <select v-model="year" class="form-control">
                                        <option value="2016">2016</option>
                                        <option value="2017">2017</option>
                                        <option value="2018">2018</option>
                                        <option value="2019">2019</option>
                                        <option value="2020">2020</option>
                                        <option value="2021">2021</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6 flex">
                                <button type="button" class="btn btn-info f-sa-end" @click="uploadData">Загрузить</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-12 text-center">
                <div>
                    <pulse-loader :loading="loading" :color="color" class="text-center"/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6" v-if="records">
                <div class="card">
                    <div class="card-header">
                        <h5>{{display_year-1}}</h5>
                    </div>
                    <div class="card-body">
                        <div v-for="(months, index) in records.old">
                            <button type="button" @click="divShow[index] = !divShow[index]" class="btn btn-default w-100 h-50p">{{allMonths[index]}} RUB: <strong>{{customFormat(months.rub)}}</strong>
                                EUR: <strong>{{customFormat(months.euro)}}</strong></button>
                            <div v-if="divShow[index]">
                                <p v-if="day.rub" v-for="(day, index2) in months">{{index2}}: RUB: <strong>{{customFormat(day.rub)}}</strong> EUR: <strong>{{customFormat(day.euro)}}</strong></p>
                            </div>
                        </div>

                        <div class="text-center p-t-10">
                            <p>Среднее значение RUB: <strong>{{customFormat(avarage.old.rub)}}</strong> EUR: <strong>{{customFormat(avarage.old.euro)}}</strong></p>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-6" v-if="records">
                <div class="card">
                    <div class="card-header">
                        <h5>{{display_year}}</h5>
                    </div>
                    <div class="card-body">
                        <div v-for="(months, index) in records.new">
                            <button type="button" @click="divShow[index] = !divShow[index]" class="btn btn-default w-100 h-50p">{{allMonths[index]}} RUB: <strong>{{customFormat(months.rub)}}</strong>
                                EUR: <strong>{{customFormat(months.euro)}}</strong> <span :class="getClassByStat(months.statistic.euro)" v-if="months.statistic">{{months.statistic.euro}}</span>
                                <span v-if="records.new[index].forecast"><br>Прогноз: RUB: <strong>{{customFormat(records.new[index].forecast.rub)}}</strong> EUR: <strong>{{customFormat(records.new[index].forecast.euro)}}</strong></span></button>
                            <div v-if="divShow[index]">
                                <p v-if="day.rub && isFinite(index2)" v-for="(day, index2) in months">{{index2}}: RUB: <strong>{{customFormat(day.rub)}}</strong> EUR: <strong>{{customFormat(day.euro)}}</strong>
                                  <span>R: <strong>{{day.rate}}</strong></span>
                                  <span :class="getClassByStat(day.statistic.euro)" v-if="day.statistic">{{day.statistic.euro}}</span>
                                </p>
                            </div>
                        </div>

                        <div class="text-center p-t-10" v-if="!currentYear">
                            <p>Среднее значение RUB: <strong>{{customFormat(avarage.new.rub)}}</strong> EUR: <strong>{{customFormat(avarage.new.euro)}}</strong></p>
                        </div>
                        <div class="text-center p-t-10" v-else>
                            <p>Среднее значение за прошедшие месяца<br>RUB: <strong>{{customFormat(avarage.no_all.rub)}}</strong> EUR: <strong>{{customFormat(avarage.no_all.euro)}}</strong></p>
                        </div>
                        <div class="text-center p-t-10" v-if="currentYear">
                            <p>Среднее значение с прогнозом RUB: <strong>{{customFormat(avarage.new.rub)}}</strong> EUR: <strong>{{customFormat(avarage.new.euro)}}</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '@/api'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


    export default {
        data() {
            return {
                year: null,
                loading: false,
                color: '#007dcc',
                records: null,
                avarage: null,
                display_year: null,
                currentYear: false,
                allMonths: {
                    1: 'Январь',
                    2: 'Февраль',
                    3: 'Март',
                    4: 'Апрель',
                    5: 'Май',
                    6: 'Июнь',
                    7: 'Июль',
                    8: 'Август',
                    9: 'Сентябрь',
                    10: 'Октябрь',
                    11: 'Ноябрь',
                    12: 'Декабрь',
                },
                divShow: {
                  1: false,
                  2: false,
                  3: false,
                  4: false,
                  5: false,
                  6: false,
                  7: false,
                  8: false,
                  9: false,
                  10: false,
                  11: false,
                  12: false,
                }
            }
        },
        components: {
            PulseLoader,
        },
        methods: {
            async uploadData() {
                if (!this.year) return;
                this.loading = true;
                let {data} = await api.post('/orders/getProfitOrdersStat', {
                    year: this.year
                })
                this.currentYear = data.current_year;
                this.display_year = this.year;
                this.records = data.sorted;
                this.avarage = data.avarage;
                this.loading = false;
            },
            getClassByStat(stat){
              return stat >= 0 ? 'stat green' : 'stat red';
            },
            customFormat(amount, decimalCount = 2, decimal = ".", thousands = " ") {
                try {
                    decimalCount = Math.abs(decimalCount);
                    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

                    const negativeSign = amount < 0 ? "-" : "";

                    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
                    let j = (i.length > 3) ? i.length % 3 : 0;

                    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
                } catch (e) {
                    console.log(e)
                }
            },
        }
    }
</script>

<style scoped>
    .w-100{
        width: 100%;
    }
    .m-0 {
        margin: 0;
    }
    .h-50p{
        height: 50px;
    }
    .flex {
        display: flex;
    }
    .p-t-10{
        padding-top: 10px;
    }
    .f-sa-end {
        align-self: flex-end;
    }
    span.stat{
        font-size: 16px;
        font-weight: 600;
        background-color: lightgray;
        padding: 1px 4px;
        border-radius: 10px;
        margin-left: 10px;
    }
    span.red{
        color: red;
    }
    span.green{
        color: green;
    }
</style>
